<template lang="pug">
  div
    .sidebar-layout__toolbar
      v-btn(
        medium
        :disabled="!allowAddAnimalGroup"
        @click="modal.showCreateGroup = true")
        v-icon.mr-1(
          position-left
          font-size="1"
          icon="plus")
        span {{ 'base.add_group' | translate }}
    v-dialog(
      max-width="400"
      v-model="modal.showCreateGroup")
      create-group-modal(
        @update="refresh"
        @close="modal.showCreateGroup = false")

    v-dialog(
      max-width="400"
      v-model="modal.showSettingsGroup"
      :value="!!selected"
      @input="selected = null")
      settings-group-modal(
        :data="selected"
        @update="refresh"
        @close="modal.showSettingsGroup = false")
    template(v-if="!isMobile")
      groups-table(
        ref="table"
        @select="onSelect")
    template(v-if="isMobile")
      groups-mobile(
        ref="tableMobile"
        @select="onSelect"
         @update="refresh"
      )
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import CreateGroupModal from './modals/CreateGroupModal'
import SettingsGroupModal from './modals/SettingsGroupModal'

const GroupsTable = () => import('./table/GroupsTable')
const GroupsMobile = () => import('./mobile/GroupsMobile')

export default {
  name: 'AnimalsGroups',

  mixins: [adaptationMixin],

  components: {
    GroupsTable,
    GroupsMobile,
    CreateGroupModal,
    SettingsGroupModal
  },

  data: () => ({
    modal: {
      showCreateGroup: false,
      showSettingsGroup: false
    },
    selected: null
  }),

  computed: {
    offset () {
      return null
    },

    allowAddAnimalGroup () {
      return this.hasPermission('group', 'add')
    }
  },

  methods: {
    onSelect (item) {
      this.selected = item
      this.modal.showSettingsGroup = true
    },

    refresh () {
      if (this.$refs.table) {
        this.$refs.table.loadData()
      }
      if (this.$refs.tableMobile) {
        this.$refs.tableMobile.loadData()
      }
    }
  }
}
</script>
